import accessMiddleware from "middleware/accessMiddleware"
import activityMiddleware from "middleware/activityMiddleware"
// import classNotesMiddleware from "middleware/classNotesMiddleware"
// import contentPostMiddleware from "middleware/contentPostMiddleware"
import customerMiddleware from "middleware/customerMiddleware"
import dataMiddleware from "middleware/dataMiddleware"
import donationsMiddleware from "middleware/donationsMiddleware"
import emailMiddleware from "middleware/emailMiddleware"
// import jobPostsMiddleware from "middleware/jobPostsMiddleware"
// import navigationMiddleware from "middleware/navigationMiddleware"
import permissionsMiddleware from "middleware/permissionsMiddleware"
import privacyMiddleware from "middleware/privacyMiddleware"
import profileMiddleware from "middleware/profileMiddleware"
import searchMiddleware from "middleware/searchMiddleware"
import tasksMiddleware from "middleware/tasksMiddleware"
// import welcomeMiddleware from "middleware/welcomeMiddleware"

// const logger = createLogger()
// let rootMiddleware = null // eslint-disable-line import/no-mutable-exports

export const MIDDLEWARES = [
  ...accessMiddleware,
  ...activityMiddleware,
  // ...classNotesMiddleware,
  ...customerMiddleware,
  ...dataMiddleware,
  ...donationsMiddleware,
  ...emailMiddleware,
  // ...jobPostsMiddleware,
  // ...navigationMiddleware,
  ...permissionsMiddleware,
  ...privacyMiddleware,
  ...profileMiddleware,
  ...searchMiddleware,
  ...tasksMiddleware,
  // ...welcomeMiddleware,
  // ...contentPostMiddleware,
]

// if (__NODE_ENV__ === "development") {
//   // eslint-disable-line no-undef
//   rootMiddleware = applyMiddleware(...MIDDLEWARES, logger)
//   // rootMiddleware = applyMiddleware(...middlewares)
// } else {
//   rootMiddleware = applyMiddleware(...MIDDLEWARES)
// }

// export default rootMiddleware
